import React from 'react';

export const LocationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 395.71 395.71"
    width={20}
    {...props}
  >
    <path
      d="M197.849 0C122.131 0 60.531 61.609 60.531 137.329c0 72.887 124.591 243.177 129.896 250.388l4.951 6.738a3.064 3.064 0 0 0 2.471 1.255 3.08 3.08 0 0 0 
    2.486-1.255l4.948-6.738c5.308-7.211 129.896-177.501 129.896-250.388C335.179 61.609 273.569 0 197.849 0zm0 88.138c27.13 0 49.191 22.062 49.191 49.191 0 
    27.115-22.062 49.191-49.191 49.191-27.114 0-49.191-22.076-49.191-49.191 0-27.129 22.076-49.191 49.191-49.191z"
    />
  </svg>
);

const KickIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 512 512"
    width={100}
    {...props}
  >
    <path
      fill="#53fc18"
      d="M37 .036h164.448v113.621h54.71v-56.82h54.731V.036h164.448v170.777h-54.73v56.82h-54.711v56.8h54.71v56.82h54.73V512.03H310.89v-56.82h-54.73v-56.8h-54.711v113.62H37V.036z"
    />
  </svg>
);

const FanslyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 800 800"
    width={100}
    {...props}
  >
    <path
      fill="#2699f7"
      d="M197.44.38c13.02.2 22.34.78 27.72 1.71 4.46.77 11.75 2.32 16.2 3.45 
      4.46 1.13 12.13 3.43 17.06 5.11s14.71 5.89 21.75 9.34 16.82 8.96 21.75 12.24 12.6 9.03 17.06 12.79 19.9 18.66 60.53 59.4l.01 
      7.67-61.85 61.79-7.65-.04-28.14-27.96c-18.84-18.71-30.12-29.26-34.12-31.89-3.28-2.16-9.23-5.46-13.22-7.35-3.99-1.88-10.9-4.4-15.35-5.59-4.46-1.19-11.94-2.48-16.63-2.87s-12.17-.4-16.63-.03-11.36 1.5-15.35 
      2.5c-3.99 1.01-10.51 3.23-14.5 4.94s-10.7 5.36-14.93 8.1c-4.22 2.74-10.98 8.29-15.03 12.34-4.04 4.04-9.6 10.8-12.34 15.02-2.75 4.22-6.39 
      10.93-8.11 14.92-1.71 3.98-3.94 10.5-4.95 14.49-1.01 3.98-2.13 10.89-2.51 15.34-.37 4.45-.36 11.93.03 16.62s1.68 12.17 2.88 16.62c1.19 4.45 
      3.71 11.36 5.59 15.34s5.19 9.93 7.34 13.21c2.75 4.19 15.24 17.32 79.97 82.25l140.72-140.49c77.4-77.27 143.99-143.08 147.97-146.24 3.99-3.16 
      10.9-8.18 15.35-11.14 4.46-2.97 11.75-7.33 16.2-9.68 4.46-2.36 12.32-6.01 17.48-8.12S545.73 9 551.36 7.38s15.22-3.85 21.32-4.94C582.37.71 
      586.5.46 605.52.46c19.01 0 23.14.25 32.84 1.98 6.1 1.09 15.69 3.31 21.32 4.94 5.63 1.62 14.46 4.68 19.62 6.79s13.03 5.79 17.48 8.17c4.46 
      2.38 11.36 6.47 15.35 9.09s10.9 7.68 15.35 11.25c4.46 3.57 12.34 10.87 17.52 16.21s11.75 12.78 14.59 16.53 7.18 9.89 9.65 13.64c2.46 3.75 
      7.3 12.57 10.75 19.6s7.8 17.39 9.66 23.01c1.86 5.63 4.35 14.64 5.53 20.03 1.19 5.39 2.56 13.06 3.05 17.05.49 3.98 1.14 12.04 1.43 17.9.3 
      6.03.1 15.83-.48 22.59-.55 6.56-1.78 15.96-2.73 20.88s-2.68 12.4-3.86 16.62-3.51 11.31-5.18 15.77c-1.67 4.45-4.68 11.55-6.7 15.77s-5.86 
      11.31-8.54 15.77c-2.68 4.45-7.44 11.55-10.57 15.77s-9.36 11.7-13.85 16.62-18.08 18.82-52.26 
      52.82l-8.53.01-29.73-29.61c-16.94-16.87-30.24-30.8-30.92-32.38-.67-1.57-.96-3.79-.65-5.11.36-1.56 9.55-11.45 
      27.54-29.62 17.65-17.83 28.51-29.49 31.34-33.67 2.38-3.52 5.68-9.08 7.33-12.36s4-9.13 5.23-13 2.81-10.39 3.52-14.49 
      1.28-10.62 1.28-14.49-.43-10-.94-13.64c-.51-3.63-1.89-9.87-3.05-13.85s-3.45-10.12-5.09-13.64c-1.63-3.52-5.02-9.46-7.51-13.21-2.5-3.75-7.18-9.52-10.4-12.81-3.22-3.3-8.54-8.02-11.82-10.49s-9.62-6.35-14.07-8.62c-4.46-2.27-11.36-5.11-15.35-6.3s-9.74-2.6-12.79-3.13-10.15-.95-15.78-.93-13.3.62-17.06 1.34c-3.75.72-9.7 2.27-13.22 3.45-3.52 1.17-8.89 3.39-11.94 4.92s-8.42 4.67-11.94 6.97c-4.73 3.1-16.23 13.97-81.91 79.31l101.08 101c92.7 
      92.62 101.08 101.23 101.08 103.77 0 1.52-.55 3.82-1.22 5.11S613.55 461.2 546.09 528.5c-92.64 92.41-123.7 122.91-126.92 124.6-2.35 1.23-6.57 2.84-9.38 3.57s-7.42 1.32-10.23 
      1.31-6.84-.43-8.96-.92c-2.11-.49-5.95-1.87-8.53-3.07-4.09-1.89-25.63-23.07-167.45-164.65-89.51-89.36-165.83-166.12-169.59-170.57s-9.26-11.74-12.21-16.19c-2.96-4.45-7.06-11.17-9.11-14.92s-5.21-10.08-7.03-14.06-4.61-11.08-6.21-15.77-3.83-12.17-4.95-16.62c-1.13-4.45-2.68-11.74-3.44-16.19-.82-4.79-1.57-15.4-1.83-26-.34-13.77-.12-20.36.96-28.55.77-5.86 2.39-15.06 3.6-20.46 1.21-5.39 3.71-14.21 5.56-19.6s5.67-14.6 
      8.48-20.46c2.82-5.86 6.89-13.53 9.05-17.05s7.22-10.8 11.23-16.19S51.04 62.3 56.68 56.66s14.67-13.53 20.06-17.54 12.69-9.06 16.2-11.22c3.52-2.16 11.19-6.23 17.06-9.05 5.86-2.81 15.07-6.63 20.47-8.48 5.39-1.85 14.22-4.35 19.62-5.57 5.39-1.21 
      13.84-2.78 18.76-3.47C175.34.41 183.2.15 197.42.37zM368.02 308.6c-2.81 1.01-8.76 3.72-13.22 6.03s-11.53 6.97-15.71 10.35-10.43 9.6-13.87 
      13.82c-4.15 5.09-7.99 11.12-11.38 17.9-3.17 6.35-5.96 13.46-7.34 18.75-1.73 6.6-2.32 11.31-2.65 20.88-.31 9.19-.07 14.22.94 19.6.75 3.98 2.16 
      9.74 3.14 12.78.98 3.05 3.44 8.99 5.47 13.21s5.97 10.74 8.76 14.49 8.01 9.6 11.61 13 9.51 8.13 13.15 10.5c3.64 2.38 8.91 5.42 11.73 6.75 2.81 1.33 7.52 
      3.22 10.45 4.2s8.11 2.37 11.51 3.1 10.02 1.55 14.71 1.82c4.95.29 11.75.06 16.2-.55 4.22-.57 10.94-1.99 14.93-3.15s10.32-3.54 14.07-5.29 
      9.89-5.27 13.65-7.82c3.75-2.56 9.89-7.72 13.65-11.47 3.75-3.75 8.92-9.89 11.48-13.64s6.08-9.89 7.83-13.64 4.12-10.08 5.28-14.06 2.58-11.08 
      3.17-15.77c.61-4.9.85-11.78.55-16.19-.28-4.22-1.09-10.36-1.79-13.64s-2.1-8.46-3.1-11.51c-1.01-3.05-3.71-9.18-6-13.64-2.3-4.45-6.05-10.59-8.35-13.64-2.29-3.05-7-8.24-10.46-11.53-3.46-3.3-9.16-7.94-12.68-10.32s-8.32-5.3-10.66-6.48c-2.35-1.18-7.72-3.37-11.94-4.85s-10.94-3.26-14.93-3.94c-3.99-.69-11.86-1.21-17.48-1.18-6.51.04-13.03.66-17.91 1.68-4.22.89-9.98 
      2.43-12.79 3.44zm33.69 29.31c3.99.19 9.28.86 11.75 1.47 3.47.86 4.37 1.41 3.94 2.4-.31.7-1.07 2.62-1.69 4.26s-1.14 4.61-1.16 6.61c-.02 1.99.72 5.64 1.65 8.1s2.79 5.82 4.14 7.46 4.52 4.13 7.05 5.54c3.97 2.21 5.48 2.56 11 2.56 5.64 0 6.97-.33 16.2-5.54l1.78 4.05c.98 2.23 2.57 7.12 3.52 10.87 1.45 5.68 1.66 8.52 1.28 17.05-.32 7.3-.99 11.81-2.32 15.77-1.03 3.05-2.98 7.65-4.34 10.23s-4.32 6.99-6.57 9.8c-2.26 2.81-6.39 6.96-9.18 9.22s-8.15 
      5.58-11.9 7.39c-3.75 1.8-9.51 3.92-12.79 4.72-4.54 1.09-8.52 1.35-16.63 1.06-8.72-.31-11.9-.8-17.48-2.7-3.75-1.28-9.51-3.98-12.79-6.01-3.31-2.04-8.82-6.68-12.37-10.41-4.59-4.83-7.41-8.77-9.97-13.95-1.97-3.97-4.2-9.71-4.97-12.76s-1.59-8.61-1.82-12.36c-.26-4.13.06-9.5.81-13.64.68-3.75 2.24-9.31 3.48-12.36s3.49-7.64 
      5.02-10.2c1.52-2.56 5.47-7.36 8.77-10.65 3.3-3.3 8.1-7.24 10.66-8.76s7.16-3.78 10.21-5.02 8.23-2.77 11.51-3.39c3.38-.65 9.11-.99 13.22-.79z"
    />
  </svg>
);

const SnapchatIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    width={100}
    {...props}
  >
    <g
      style={{
        stroke: 'none',
        strokeWidth: 0,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: 10,
        fill: 'none',
        fillRule: 'nonzero',
        opacity: 1,
      }}
    >
      <path
        d="M.035 67.109v.004c.054 1.998.07 4.007.407 5.993.357 2.101.868 4.149 1.842 6.056a19.365 19.365 0 0 0 5.408 6.54c1.639 1.278 3.429 2.293 5.411 2.933 2.89.932 5.871 1.289 8.896 1.307 1.887.012 3.773.059 5.661.051 13.71-.058 27.42.099 41.13-.085 1.819-.025 3.609-.247 5.394-.573 3.422-.626 6.447-2.087 9.035-4.395 3.016-2.69 5.051-5.982 5.969-9.955.601-2.597.751-5.232.777-7.876v-.527c0-.205-.078-44.926-.085-45.517-.02-1.624-.14-3.235-.444-4.833-.37-1.947-.893-3.844-1.826-5.606a19.45 19.45 0 0 0-3.743-4.996c-2.336-2.24-5.032-3.825-8.171-4.663-2.835-.757-5.727-.924-8.64-.922-.004-.001-.015-.031-.016-.045H22.946l-.002.045c-1.653.03-3.309.018-4.954.222-1.802.224-3.587.561-5.292 1.191-2.688.993-5.022 2.541-7.016 4.607-2.259 2.341-3.851 5.048-4.696 8.201-.754 2.813-.918 5.682-.922 8.571"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#fffc00',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
      <path
        d="M45.408 75.934c-.187 0-.365-.007-.501-.013a3.992 3.992 0 0 1-.33.013c-3.924 0-6.547-1.855-8.863-3.493-1.659-1.172-3.224-2.279-5.058-2.584-.9-.149-1.796-.225-2.662-.225-1.559 0-2.792.242-3.692.418-.554.108-1.031.201-1.4.201-.386 0-.856-.086-1.052-.754-.155-.527-.266-1.038-.374-1.53-.269-1.229-.463-1.979-.924-2.05-4.921-.759-7.829-1.878-8.408-3.233a1.259 1.259 0 0 1-.102-.427.79.79 0 0 1 .661-.824c3.908-.644 7.383-2.709 10.329-6.142 2.282-2.657 3.403-5.196 3.523-5.477a.264.264 0 0 1 .018-.038c.568-1.152.681-2.148.337-2.958-.634-1.495-2.734-2.162-4.124-2.603a14.93 14.93 0 0 1-.933-.316c-1.232-.487-3.257-1.514-2.988-2.933.197-1.035 1.565-1.755 2.671-1.755a1.9 1.9 0 0 1 .808.161c1.25.586 2.374.882 3.341.882 1.202 0 1.783-.458 1.924-.588-.036-.657-.076-1.313-.119-1.97-.282-4.49-.634-10.078.795-13.282 4.278-9.592 13.35-10.338 16.028-10.338l1.326-.012c2.685 0 11.776.747 16.057 10.344 1.429 3.206 1.077 8.799.794 13.294l-.013.215c-.039.61-.075 1.188-.105 1.748.132.122.664.541 1.745.584.922-.035 1.981-.331 3.148-.877.361-.169.76-.204 1.031-.204.41 0 .827.08 1.174.225l.019.007c.99.351 1.638 1.053 1.652 1.791.012.688-.499 1.715-3.012 2.708-.257.102-.586.206-.933.316-1.391.441-3.489 1.107-4.123 2.602-.345.811-.231 1.806.337 2.958l.018.039c.175.41 4.408 10.062 13.852 11.618a.792.792 0 0 1 .661.824 1.256 1.256 0 0 1-.105.431c-.575 1.347-3.483 2.464-8.406 3.224-.462.071-.657.818-.923 2.041-.11.505-.222 1-.375 1.52-.143.489-.462.728-.974.728h-.077c-.333 0-.805-.061-1.4-.177-1.041-.203-2.208-.391-3.692-.391-.865 0-1.761.076-2.662.225-1.832.305-3.396 1.41-5.053 2.581-2.318 1.641-4.943 3.496-8.866 3.496"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#fff',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
      <path
        d="M45.641 14.856c2.528 0 11.233.679 15.335 9.876 1.351 3.028 1.005 8.514.727 12.921-.043.699-.086 1.377-.121 2.024l-.015.278.186.207c.075.083.777.817 2.339.877l.025.001.026-.001c1.033-.039 2.195-.36 3.458-.952.186-.087.434-.13.696-.13.299 0 .616.056.877.166l.04.016c.662.232 1.13.67 1.138 1.066.004.224-.164 1.03-2.511 1.958-.229.091-.531.187-.882.297-1.528.485-3.836 1.217-4.613 3.048-.437 1.031-.318 2.248.356 3.616.277.647 4.638 10.469 14.451 12.086a.423.423 0 0 1-.04.157c-.166.392-1.223 1.745-7.802 2.76-1.029.158-1.282 1.312-1.574 2.653-.106.48-.213.965-.361 1.466-.045.151-.054.16-.216.16h-.077c-.292 0-.735-.061-1.248-.161-.935-.182-2.212-.405-3.844-.405-.911 0-1.85.079-2.791.236-2.013.335-3.65 1.493-5.384 2.718-2.328 1.645-4.735 3.348-8.407 3.348-.16 0-.317-.005-.474-.013l-.041-.002-.041.003c-.09.008-.181.012-.274.012-3.671 0-6.079-1.702-8.406-3.348-1.734-1.226-3.372-2.383-5.385-2.718a17.017 17.017 0 0 0-2.791-.236c-1.632 0-2.911.25-3.844.432-.513.1-.958.186-1.248.186-.238 0-.243-.014-.293-.186-.148-.501-.256-.997-.361-1.477-.293-1.343-.545-2.503-1.574-2.661-6.578-1.016-7.635-2.372-7.802-2.762a.47.47 0 0 1-.04-.161c9.813-1.616 14.173-11.439 14.451-12.088.675-1.367.794-2.584.355-3.616-.777-1.829-3.085-2.563-4.611-3.047a15.26 15.26 0 0 1-.883-.298c-1.982-.783-2.592-1.572-2.502-2.05C19.75 40.561 20.706 40 21.54 40c.187 0 .352.03.473.087 1.355.635 2.592.957 3.676.957 1.705 0 2.464-.793 2.546-.884l.185-.207-.015-.277c-.034-.647-.077-1.325-.122-2.023-.277-4.408-.623-9.89.727-12.919 4.087-9.163 12.749-9.87 15.307-9.87l1.175-.011c.046.004.096.003.149.003m0-1.58h-.003l-.165.001-1.16.012c-1.498 0-4.495.212-7.715 1.633a17.184 17.184 0 0 0-4.921 3.263c-1.698 1.613-3.082 3.601-4.112 5.91-1.508 3.382-1.15 9.077-.863 13.654l.001.007.093 1.501c-.221.102-.58.209-1.109.209-.851 0-1.862-.272-3.006-.808a2.684 2.684 0 0 0-1.144-.236c-.681 0-1.399.2-2.021.566-.783.46-1.289 1.11-1.427 1.831-.091.477-.086 1.419.96 2.375.576.526 1.421 1.011 2.513 1.443.286.113.626.221.987.335 1.25.397 3.141.997 3.634 2.158.25.588.142 1.363-.319 2.299l-.035.077c-.115.269-1.19 2.705-3.396 5.273-1.253 1.461-2.634 2.681-4.1 3.629-1.79 1.157-3.728 1.914-5.758 2.248a1.581 1.581 0 0 0-1.322 1.648c.014.233.068.464.163.689l.002.004c.322.754 1.07 1.394 2.284 1.959 1.485.69 3.705 1.27 6.599 1.723.146.278.298.977.403 1.455.11.509.225 1.031.388 1.587.176.602.634 1.321 1.81 1.321.446 0 .958-.1 1.551-.215.869-.171 2.057-.403 3.54-.403.822 0 1.675.072 2.532.215 1.654.275 3.079 1.282 4.728 2.448 2.414 1.707 5.147 3.638 9.322 3.638.114 0 .228-.004.341-.012.138.006.309.012.489.012 4.176 0 6.908-1.932 9.319-3.637l.004-.003c1.65-1.165 3.074-2.17 4.727-2.446a15.551 15.551 0 0 1 2.532-.215c1.417 0 2.539.181 3.54.376.654.129 1.162.191 1.552.191l.038.001h.04c.86 0 1.492-.472 1.733-1.298.16-.544.275-1.054.387-1.571.098-.448.255-1.167.402-1.448 2.896-.455 5.115-1.034 6.6-1.723 1.212-.562 1.959-1.202 2.283-1.953.097-.225.154-.458.167-.696a1.58 1.58 0 0 0-1.322-1.648c-9.021-1.487-13.085-10.756-13.253-11.15a1.078 1.078 0 0 0-.036-.077c-.461-.936-.568-1.71-.318-2.299.492-1.16 2.382-1.76 3.632-2.157.362-.114.703-.222.987-.335 1.231-.486 2.111-1.014 2.691-1.613.693-.714.828-1.398.82-1.846-.021-1.083-.849-2.046-2.166-2.517a3.874 3.874 0 0 0-1.469-.281c-.352 0-.872.048-1.365.278-1.055.494-2.001.764-2.812.802a2.528 2.528 0 0 1-.93-.205l.08-1.309.012-.194c.289-4.58.648-10.28-.86-13.664-1.034-2.318-2.423-4.311-4.128-5.927a17.231 17.231 0 0 0-4.939-3.263 19.617 19.617 0 0 0-7.712-1.622"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#020202',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
    </g>
  </svg>
);

const DiscordIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    width={100}
    {...props}
  >
    <g
      style={{
        stroke: 'none',
        strokeWidth: 0,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: 10,
        fill: 'none',
        fillRule: 'nonzero',
        opacity: 1,
      }}
      transform="matrix(2.81 0 0 2.81 1.407 1.407)"
    >
      <circle
        cx={45}
        cy={45}
        r={45}
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#7289da',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <path
        d="M56.901 62.98s-1.541-1.841-2.825-3.467c5.608-1.584 7.748-5.094 7.748-5.094-1.755 1.156-3.425 1.969-4.923 2.526-2.14.899-4.195 1.498-6.207 1.841-4.11.771-7.877.557-11.087-.043a35.938 35.938 0 0 1-6.293-1.841 25.046 25.046 0 0 1-3.125-1.455c-.128-.086-.257-.128-.385-.214-.086-.043-.128-.086-.171-.128-.771-.428-1.199-.728-1.199-.728s2.055 3.425 7.491 5.051a269.297 269.297 0 0 1-2.868 3.553C23.596 62.68 20 56.473 20 56.473c0-13.784 6.164-24.957 6.164-24.957 6.164-4.623 12.029-4.495 12.029-4.495l.428.514c-7.705 2.226-11.259 5.608-11.259 5.608s.942-.514 2.526-1.241c4.58-2.012 8.219-2.568 9.717-2.697.257-.043.471-.086.728-.086a36.266 36.266 0 0 1 8.647-.086 34.897 34.897 0 0 1 12.885 4.11s-3.382-3.211-10.659-5.437l.599-.685s5.865-.128 12.029 4.495c0 0 6.164 11.173 6.164 24.957.002 0-3.637 6.207-13.097 6.507z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#fff',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <path
        d="M36.995 42.988c-2.44 0-4.366 2.14-4.366 4.752 0 2.611 1.969 4.752 4.366 4.752 2.44 0 4.366-2.14 4.366-4.752.043-2.611-1.926-4.752-4.366-4.752zm15.625 0c-2.44 0-4.366 2.14-4.366 4.752 0 2.611 1.969 4.752 4.366 4.752 2.44 0 4.366-2.14 4.366-4.752 0-2.611-1.926-4.752-4.366-4.752z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#7289da',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
    </g>
  </svg>
);

const RedditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    width={100}
    {...props}
  >
    <g
      style={{
        stroke: 'none',
        strokeWidth: 0,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: 10,
        fill: 'none',
        fillRule: 'nonzero',
        opacity: 1,
      }}
      transform="matrix(2.81 0 0 2.81 1.407 1.407)"
    >
      <circle
        cx={45}
        cy={45}
        r={45}
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#ff4500',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <path
        d="M75.011 45c-.134-3.624-3.177-6.454-6.812-6.331a6.594 6.594 0 0 0-4.306 1.823 31.99 31.99 0 0 0-17.327-5.537l2.919-14.038 9.631 2.025a4.497 4.497 0 0 0 4.955 3.993c2.472-.268 4.262-2.483 3.993-4.955s-2.483-4.262-4.955-3.993a4.45 4.45 0 0 0-3.4 2.204L48.68 17.987a1.395 1.395 0 0 0-1.667 1.063v.022l-3.322 15.615a32.238 32.238 0 0 0-17.55 5.537 6.562 6.562 0 0 0-9.284.291 6.562 6.562 0 0 0 .291 9.284 6.372 6.372 0 0 0 1.767 1.186c-.045.66-.045 1.32 0 1.98 0 10.078 11.745 18.277 26.23 18.277 14.485 0 26.23-8.188 26.23-18.277.045-.66.045-1.32 0-1.98A6.57 6.57 0 0 0 75.011 45zm-45 4.508A4.517 4.517 0 0 1 34.519 45c2.483 0 4.508 2.025 4.508 4.508s-2.025 4.508-4.508 4.508c-2.494-.023-4.508-2.025-4.508-4.508zm26.141 12.55v-.179a17.282 17.282 0 0 1-11.119 3.468 17.278 17.278 0 0 1-11.119-3.468 1.215 1.215 0 0 1 1.712-1.711 14.697 14.697 0 0 0 9.362 2.83 14.811 14.811 0 0 0 9.407-2.74 1.267 1.267 0 0 1 1.779.022c.481.492.47 1.297-.022 1.778zm-.615-7.718h-.224l.034-.168c-2.483 0-4.508-2.025-4.508-4.508s2.025-4.508 4.508-4.508 4.508 2.025 4.508 4.508a4.501 4.501 0 0 1-4.318 4.676z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#fff',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
    </g>
  </svg>
);

const TwitchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    width={100}
    {...props}
  >
    <g
      style={{
        stroke: 'none',
        strokeWidth: 0,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: 10,
        fill: 'none',
        fillRule: 'nonzero',
        opacity: 1,
      }}
      transform="matrix(2.81 0 0 2.81 1.407 1.407)"
    >
      <circle
        cx={45}
        cy={45}
        r={45}
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#9146ff',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <path
        d="m64.64 46.04-7.85 7.85h-7.86l-6.88 6.88v-6.88h-8.84V24.43h31.43z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#9146ff',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <path
        d="m31.25 20.5-9.821 9.821v35.357h11.786V75.5l9.821-9.821h7.857L68.571 48V20.5H31.25zm33.393 25.536-7.857 7.857h-7.857l-6.875 6.875v-6.875h-8.839V24.429h31.429v21.607z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#fff',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <rect
        width={3.93}
        height={11.79}
        x={54.82}
        y={31.3}
        rx={0}
        ry={0}
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#fff',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <rect
        width={3.93}
        height={11.79}
        x={44.02}
        y={31.3}
        rx={0}
        ry={0}
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#fff',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
    </g>
  </svg>
);

const TiktokIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    width={100}
    {...props}
  >
    <g
      style={{
        stroke: 'none',
        strokeWidth: 0,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: 10,
        fill: 'none',
        fillRule: 'nonzero',
        opacity: 1,
      }}
    >
      <path
        d="M36.203 35.438v-3.51a27.092 27.092 0 0 0-3.677-.268c-15.047 0-27.289 12.244-27.289 27.291 0 9.23 4.613 17.401 11.65 22.342a27.18 27.18 0 0 1-7.328-18.58c0-14.833 11.894-26.929 26.644-27.275"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#00f2ea',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
      <path
        d="M36.847 75.175c6.714 0 12.19-5.341 12.44-11.997l.023-59.417h10.855a20.558 20.558 0 0 1-.35-3.762H44.989l-.025 59.419c-.247 6.654-5.726 11.993-12.438 11.993-2.015.001-4-.49-5.782-1.431a12.444 12.444 0 0 0 10.103 5.195M80.441 23.93v-3.302a20.496 20.496 0 0 1-11.232-3.339 20.632 20.632 0 0 0 11.234 6.641"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#00f2ea',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
      <path
        d="M69.209 17.286a20.537 20.537 0 0 1-5.073-13.522h-3.972a20.664 20.664 0 0 0 9.045 13.522m-36.683 29.2c-6.88.008-12.455 5.583-12.463 12.463a12.47 12.47 0 0 0 6.679 11.032 12.378 12.378 0 0 1-2.358-7.268c.007-6.88 5.582-12.457 12.463-12.465 1.284 0 2.515.212 3.677.577V35.689a27.092 27.092 0 0 0-3.677-.268c-.216 0-.429.012-.643.016v11.626a12.279 12.279 0 0 0-3.678-.577"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#ff004f',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
      <path
        d="M80.441 23.93v11.523a35.261 35.261 0 0 1-20.627-6.633v30.13c0 15.047-12.24 27.289-27.287 27.289a27.128 27.128 0 0 1-15.639-4.947 27.21 27.21 0 0 0 19.959 8.709c15.047 0 27.289-12.242 27.289-27.287v-30.13a35.26 35.26 0 0 0 20.627 6.633v-14.83c-1.484 0-2.927-.161-4.323-.46"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#ff004f',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
      <path
        d="M59.813 58.949v-30.13a35.252 35.252 0 0 0 20.627 6.633V23.93a20.631 20.631 0 0 1-11.232-6.644 20.664 20.664 0 0 1-9.045-13.522H49.309l-.023 59.417c-.249 6.654-5.726 11.995-12.44 11.995a12.446 12.446 0 0 1-10.102-5.194 12.471 12.471 0 0 1-6.681-11.032c.008-6.88 5.583-12.455 12.463-12.463 1.282 0 2.513.21 3.677.577V35.438c-14.75.346-26.644 12.442-26.644 27.275 0 7.173 2.787 13.703 7.328 18.58a27.125 27.125 0 0 0 15.639 4.945c15.048 0 27.287-12.242 27.287-27.289"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#000',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
    </g>
  </svg>
);

const TwitterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    width={100}
    {...props}
  >
    <g
      style={{
        stroke: 'none',
        strokeWidth: 0,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: 10,
        fill: 'none',
        fillRule: 'nonzero',
        opacity: 1,
      }}
    >
      <path
        d="m24.89 23.01 32.9 43.98h7.45l-32.9-43.98z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#000',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
      <path
        d="M45 0C20.147 0 0 20.147 0 45s20.147 45 45 45 45-20.147 45-45S69.853 0 45 0zm11.032 70.504L41.054 50.477 22.516 70.504h-4.765L38.925 47.63 17.884 19.496h16.217L47.895 37.94l17.072-18.444h4.765L50.024 40.788l22.225 29.716H56.032z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#000',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
    </g>
  </svg>
);

const YoutubeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    width={100}
    {...props}
  >
    <g
      style={{
        stroke: 'none',
        strokeWidth: 0,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: 10,
        fill: 'none',
        fillRule: 'nonzero',
        opacity: 1,
      }}
    >
      <path
        d="M88.119 23.338a11.273 11.273 0 0 0-7.957-7.957C73.144 13.5 45 13.5 45 13.5s-28.144 0-35.162 1.881a11.273 11.273 0 0 0-7.957 7.957C0 30.356 0 45 0 45s0 14.644 1.881 21.662a11.273 11.273 0 0 0 7.957 7.957C16.856 76.5 45 76.5 45 76.5s28.144 0 35.162-1.881a11.273 11.273 0 0 0 7.957-7.957C90 59.644 90 45 90 45s0-14.644-1.881-21.662z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: 'red',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
      <path
        d="M36 58.5 59.38 45 36 31.5z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#fff',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
    </g>
  </svg>
);

const InstagramIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    width={100}
    {...props}
  >
    <g
      style={{
        stroke: 'none',
        strokeWidth: 0,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: 10,
        fill: 'none',
        fillRule: 'nonzero',
        opacity: 1,
      }}
      transform="matrix(2.81 0 0 2.81 1.407 1.407)"
    >
      <linearGradient
        id="a"
        x1={7.553}
        x2={82.447}
        y1={9.553}
        y2={84.448}
        gradientTransform="matrix(1 0 0 -1 0 92)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0%"
          style={{
            stopColor: '#ffd600',
            stopOpacity: 1,
          }}
        />
        <stop
          offset="50%"
          style={{
            stopColor: '#ff0100',
            stopOpacity: 1,
          }}
        />
        <stop
          offset="100%"
          style={{
            stopColor: '#d800b9',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <path
        d="M89.729 26.447c-.219-4.79-.98-8.061-2.092-10.923a22.062 22.062 0 0 0-5.19-7.971 22.058 22.058 0 0 0-7.971-5.192C71.614 1.25 68.343.49 63.553.272 58.754.053 57.221 0 45 0S31.246.053 26.447.271c-4.79.219-8.061.98-10.923 2.092a22.062 22.062 0 0 0-7.971 5.19 22.054 22.054 0 0 0-5.192 7.97C1.25 18.386.49 21.657.272 26.446.052 31.246 0 32.779 0 45c0 12.222.052 13.755.272 18.554.218 4.789.979 8.061 2.092 10.923a22.058 22.058 0 0 0 5.19 7.97 22.04 22.04 0 0 0 7.971 5.19c2.862 1.113 6.133 1.873 10.923 2.092 4.799.219 6.332.271 18.553.271s13.754-.051 18.553-.271c4.79-.219 8.061-.979 10.923-2.092a23.003 23.003 0 0 0 13.16-13.16c1.113-2.863 1.873-6.134 2.092-10.923.219-4.8.271-6.333.271-18.554 0-12.221-.052-13.754-.271-18.553zm-8.1 36.738c-.2 4.388-.933 6.77-1.549 8.356a14.902 14.902 0 0 1-8.54 8.54c-1.585.616-3.968 1.349-8.356 1.549-4.744.217-6.168.262-18.184.262-12.017 0-13.44-.045-18.184-.262-4.387-.2-6.77-.933-8.356-1.549a13.954 13.954 0 0 1-5.174-3.367 13.946 13.946 0 0 1-3.367-5.174c-.616-1.585-1.349-3.968-1.549-8.356-.216-4.745-.262-6.168-.262-18.184 0-12.016.046-13.439.262-18.184.201-4.388.933-6.77 1.549-8.356a13.95 13.95 0 0 1 3.367-5.175 13.935 13.935 0 0 1 5.175-3.366c1.585-.617 3.968-1.349 8.356-1.55 4.744-.215 6.167-.261 18.183-.261h-.001c12.016 0 13.439.046 18.184.263 4.388.2 6.77.933 8.356 1.549a13.964 13.964 0 0 1 5.174 3.366 13.935 13.935 0 0 1 3.366 5.175c.617 1.585 1.35 3.968 1.55 8.356.216 4.745.262 6.168.262 18.184 0 12.016-.045 13.438-.262 18.184z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: 'url(#a)',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <linearGradient
        id="b"
        x1={28.66}
        x2={61.339}
        y1={30.66}
        y2={63.34}
        gradientTransform="matrix(1 0 0 -1 0 92)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0%"
          style={{
            stopColor: '#ff6400',
            stopOpacity: 1,
          }}
        />
        <stop
          offset="50%"
          style={{
            stopColor: '#ff0100',
            stopOpacity: 1,
          }}
        />
        <stop
          offset="100%"
          style={{
            stopColor: '#fd0056',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <path
        d="M44.999 21.892c-12.762 0-23.108 10.346-23.108 23.108s10.346 23.108 23.108 23.108c12.763 0 23.108-10.346 23.108-23.108S57.762 21.892 44.999 21.892zm0 38.108C36.716 59.999 30 53.284 30 45c0-8.284 6.715-15 15-15 8.284.001 15 6.716 15 15 0 8.284-6.716 15-15.001 15z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: 'url(#b)',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <linearGradient
        id="c"
        x1={65.202}
        x2={72.839}
        y1={67.202}
        y2={74.839}
        gradientTransform="matrix(1 0 0 -1 0 92)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0%"
          style={{
            stopColor: '#f30072',
            stopOpacity: 1,
          }}
        />
        <stop
          offset="100%"
          style={{
            stopColor: '#e50097',
            stopOpacity: 1,
          }}
        />
      </linearGradient>
      <path
        d="M74.421 20.979a5.4 5.4 0 1 1-10.8 0 5.4 5.4 0 0 1 10.8 0z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: 'url(#c)',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
    </g>
  </svg>
);

const OnlyfansIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 256 256"
    width={100}
    {...props}
  >
    <g
      style={{
        stroke: 'none',
        strokeWidth: 0,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: 10,
        fill: 'none',
        fillRule: 'nonzero',
        opacity: 1,
      }}
    >
      <path
        d="M30 15C13.431 15 0 28.431 0 45s13.431 30 30 30 30-13.431 30-30-13.431-30-30-30zm0 39c-4.971 0-9-4.029-9-9s4.029-9 9-9 9 4.029 9 9a8.988 8.988 0 0 1-8.976 9H30z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#00aeef',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
      <path
        d="M63.72 37.5c7.622 2.194 16.62 0 16.62 0-2.611 11.4-10.891 18.54-22.831 19.409A29.935 29.935 0 0 1 30 75l9-28.606C48.252 16.992 52.994 15 74.935 15H90c-2.52 11.1-11.206 19.579-26.28 22.5z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#008ccf',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      />
    </g>
  </svg>
);

const FacebookIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#0766ff"
    viewBox="0 0 16 16"
    width={100}
    {...props}
  >
    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
  </svg>
);

export const PLATFORM_ICON_MAP = {
  Onlyfans: (props) => <OnlyfansIcon props={props} />,
  Instagram: (props) => <InstagramIcon props={props} />,
  Youtube: (props) => <YoutubeIcon props={props} />,
  Twitter: (props) => <TwitterIcon props={props} />,
  Tiktok: (props) => <TiktokIcon props={props} />,
  Twitch: (props) => <TwitchIcon props={props} />,
  Fansly: (props) => <FanslyIcon props={props} />,
  Reddit: (props) => <RedditIcon props={props} />,
  Discord: (props) => <DiscordIcon props={props} />,
  Kick: (props) => <KickIcon props={props} />,
  Snapchat: (props) => <SnapchatIcon props={props} />,
  Facebook: (props) => <FacebookIcon props={props} />,
};
